module.exports = __webpack_public_path__ + "img/mark-light.64a3d57a.svg";